const api = () => {
  const _protocol = 'http://';
  // const _host = '40.114.94.56';
  // const _port = '80';
  const _host = 'localhost';
  const _port = '8080';
  // const _tokenCode = 'jwtkn';
  const _tokenCode = 'x-auth-token';

  const MQ_ENDPOINT = 'ws://13.92.42.65:61614/stomp';
  const WEBSITE_ENDPOINT = 'https://rentaskip.com.au';

  return Object.freeze({
    PATHS: {
      APP: `${_protocol}${_host}:${_port}`,
      MQ: `${MQ_ENDPOINT}`,
      WEBSITE: `${WEBSITE_ENDPOINT}`
    },
    getTokenCode () {
      return _tokenCode;
    }
  });
};

api.$inject = [];
export { api };



/** WEBPACK FOOTER **
 ** ./src/app/shared/services/api.js
 **/